<template>
  <modal 
    name="template-type-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'650px'"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        What type of template would you like to add?
      </div>

      <a href="#"
        v-on:click.prevent="$modal.hide('template-type-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body">
      <div class="flex flex-wrap -mx-2">
				<div class="w-1/3 px-2">
          <button class="item-button" v-on:click="templateTypeSelected('asset')">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Money-Graph-256.png" class="inline w-16" />
            <div class="mt-2">Asset template</div>
          </button>
        </div>

        <div class="w-1/3 px-2">
          <button class="item-button" v-on:click="templateTypeSelected('liability')">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Old-Car-2-256.png" class="inline w-16" />
            <div class="mt-2">Liability Template</div>
          </button>
        </div>

        <div class="w-1/3 px-2">
          <button class="item-button" v-on:click="templateTypeSelected('document')">
            <img src="https://cdn0.iconfinder.com/data/icons/kameleon-free-pack-rounded/110/Checklist-256.png" class="inline w-16" />
            <div class="mt-2">Document Template</div>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {

    data() {
      return {
        addAsset : null,
        brokerId : null
      }
    },

    methods : {
      beforeOpen(event) {
        // this.addAsset = event.params.addAsset
        if(event.params.brokerId) {
          this.brokerId = event.params.brokerId
        }
      },

      templateTypeSelected(type) {
        if(type == 'asset') {
          this.$modal.show('asset-template-modal', {
            template : null,
            brokerId : this.brokerId
          })
        } else if(type == 'liability') {
          this.$modal.show('liability-template-modal', {
            template : null,
            brokerId : this.brokerId
          })
        } else if(type == 'document') {
          this.$modal.show('document-template-modal', {
            template : null,
            brokerId : this.brokerId
          })
        }
        
        this.$modal.hide('template-type-modal')
      }
    }
  }
</script>